import {
  BUSINESS_MEMBER_ROLES,
  normalizeUserRole,
  USER_ROLES,
  UserRole,
} from "../constants/userRoles";

const ADMIN_ROLES: readonly UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.ADMIN,
];

const BUSINESS_OPERATION_ROLES: readonly UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.STAFF,
  USER_ROLES.SHOP,
];

export const isSuperAdminRole = (role?: string | null): boolean =>
  normalizeUserRole(role) === USER_ROLES.SUPER_ADMIN;

export const isAdminRole = (role?: string | null): boolean =>
  normalizeUserRole(role) === USER_ROLES.ADMIN;

export const canManageAllUsers = (role?: string | null): boolean =>
  isSuperAdminRole(role);

export const canManageOwnMembers = (role?: string | null): boolean => {
  const normalizedRole: UserRole = normalizeUserRole(role);

  return ADMIN_ROLES.includes(normalizedRole);
};

export const canManageBusinessSettings = (role?: string | null): boolean => {
  const normalizedRole: UserRole = normalizeUserRole(role);

  return ADMIN_ROLES.includes(normalizedRole);
};

export const canManageBusinessOperations = (role?: string | null): boolean => {
  const normalizedRole: UserRole = normalizeUserRole(role);

  return BUSINESS_OPERATION_ROLES.includes(normalizedRole);
};

export const getAssignableMemberRoles = (
  viewerRole?: string | null,
): UserRole[] => {
  if (isSuperAdminRole(viewerRole)) {
    return [...BUSINESS_MEMBER_ROLES];
  }

  if (isAdminRole(viewerRole)) {
    return BUSINESS_MEMBER_ROLES.filter(
      (role: UserRole) => role !== USER_ROLES.ADMIN,
    );
  }

  return [];
};
